"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

/**
 * Options for the victory bar plugin.
 *
 * @typedef victoryBarPluginOptions
 * @type {object}
 * @property {object} theme - The Victory theme being used for the chart (i.e.
 *   the object returned from the `useVictoryTheme` hook).
 */

/**
 * Integrate a `VictoryBar` component with the Meridian `Legend` component.
 *
 * See the [Bar data visualization documentation](https://meridian.a2z.com/data-visualization/bar/?platform=react-web)
 * for details on usage.
 *
 * @param {victoryBarPluginOptions} options - Configuration for the plugin.
 *
 * @return {*} - The instantiated plugin to be passed to the `LegendProvider`
 *   component's `plugins` prop.
 */
var victoryBarPlugin = function victoryBarPlugin(_ref) {
  var theme = _ref.theme;
  return function (legend) {
    // Track the active x value/group in the voronoi container
    var _useState = (0, _react.useState)(),
        _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
        activeX = _useState2[0],
        setActiveX = _useState2[1];

    var somethingActivated = (0, _react.useRef)();
    var onVoronoiContainerActivated = (0, _react.useCallback)(function (points) {
      somethingActivated.current = true;
      var x = points.length && points[0].xName;

      if (x !== activeX) {
        setActiveX(x);
      }
    }, [activeX]);
    var onVoronoiContainerDeactivated = (0, _react.useCallback)(function () {
      if (!somethingActivated.current) {
        setActiveX();
      }

      somethingActivated.current = false;
    }, []);
    /**
     * Generates props for a VictoryBar component given the legend key of the
     * data.
     */

    var getBarProps = (0, _react.useCallback)(function (key) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          stackedIndex = _ref2.stackedIndex;

      return {
        style: {
          data: {
            key: key,
            fill: legend.getItem(key).color,
            fillOpacity: legend.getState(key) === "inactive" ? 0.2 : function (point) {
              return activeX === undefined || point.datum.xName === activeX ? 1 : 0.2;
            },
            strokeOpacity: legend.getState(key) === "inactive" ? 0.2 : function (point) {
              return activeX === undefined || point.datum.xName === activeX ? 1 : 0.2;
            },
            transition: "all 0.2s ease"
          }
        },
        // Set the corner radius for a VictoryBar inside a VictoryStack so that
        // only the bars on the top of the stack are rounded
        cornerRadius: stackedIndex === undefined ? undefined : stackedIndex === legend.data.length - 1 ? theme.bar.cornerRadius : 0
      };
    }, [legend, activeX]);
    return {
      api: {
        getBarProps: getBarProps,
        voronoiContainerProps: {
          voronoiDimension: "x",
          title: legend["aria-label"],
          "aria-describedby": legend["aria-describedby"],
          "aria-labelledby": legend["aria-labelledby"],
          onActivated: onVoronoiContainerActivated,
          onDeactivated: onVoronoiContainerDeactivated
        }
      }
    };
  };
};

var _default = victoryBarPlugin;
exports["default"] = _default;